import React from 'react';

import { withAlertContext, AlertProvider } from '@carta/ink';
import ExposeDescribe from './ExposeDescribe';
import { RenderCode } from '../RenderCode';
import convertSampleName from '../helpers/convertSampleName';

const ExposeTemplate = ({ sample, ...otherProps }) => (
  <AlertProvider>
    <ExposeDescribe
      id={convertSampleName(sample.name)}
      name={sample.name}
      description={sample.description}
      environments={sample.environments}
      code={sample.code}
    >
      <RenderCode code={sample.code} props={otherProps} />
    </ExposeDescribe>
  </AlertProvider>
);

export default withAlertContext(ExposeTemplate);
